import { render, staticRenderFns } from "./TarifariosTarifasAdicionales.vue?vue&type=template&id=57dd7592"
import script from "./TarifariosTarifasAdicionales.vue?vue&type=script&lang=js"
export * from "./TarifariosTarifasAdicionales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports